import { connect } from 'react-redux';

import LoadingStateProvider from '../../../components/LoadingStateProvider';

const mapStateToProps = ({ loading }) => loading;

export default connect(mapStateToProps)(LoadingStateProvider);
